var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6565 5.83331H27.344C29.8713 5.83331 31.9366 7.81147 32.0761 10.304L32.0836 10.5729V24.4271C32.0836 26.9544 30.1054 29.0196 27.6129 29.1592L27.344 29.1666H7.6565C5.12916 29.1666 3.06384 27.1884 2.92441 24.696L2.91692 24.4271V10.5729C2.91692 8.04556 4.89507 5.98024 7.38755 5.84081L7.6565 5.83331ZM29.8961 13.6689L18.0096 19.9262C17.7364 20.07 17.4173 20.0906 17.131 19.9879L16.9909 19.9262L5.10442 13.6704V24.4271C5.10442 25.7661 6.13562 26.8642 7.44718 26.9707L7.6565 26.9791H27.344C28.683 26.9791 29.7812 25.948 29.8876 24.6363L29.8961 24.4271V13.6689ZM27.344 8.02081H7.6565C6.3175 8.02081 5.21935 9.05202 5.11287 10.3636L5.10442 10.5729V11.1985L17.5002 17.7224L29.8961 11.1971V10.5729C29.8961 9.2339 28.8649 8.13574 27.5533 8.02927L27.344 8.02081Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts1);
export default __webpack_public_path__ + "static/media/contacts-1.e2c6e88b8043f2fe7f7809aa1a6256f0.svg";
export { ForwardRef as ReactComponent };